import { HttpErrorResponse,HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpService } from '../http/http.service';
import { catchError} from 'rxjs/operators';
import { environment } from 'src/environments/environment';


@Injectable({
    providedIn: 'root'
})
export class cityService {
    constructor(private httpService: HttpService) { }


    getallcity(data: any) {
        const url = `${environment.SettingsApiendpoint}/get-city-list?${data}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    getallstateandId() {
        const url = `${environment.SettingsApiendpoint}/get-state-list`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    getallCitysandbyId(state_id:any) {
        const url = `${environment.SettingsApiendpoint}/cities-by-state-id/${state_id}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    getallcitysSelectedState(state_id:any) {
        const url = `${environment.SettingsApiendpoint}/cities-by-state-id/${state_id}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    getallcityandId() {
        const url = `${environment.SettingsApiendpoint}/cities?d=all`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    getallareacodeandId(cityid: any) {
        const url = `${environment.SettingsApiendpoint}/area-codes-by-city-id/${cityid}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    getallpincodeandId(areacode_id: any) {
        const url = `${environment.SettingsApiendpoint}/pincode-by-areacode-id/${areacode_id}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    getCityStateByPincode(pincode: any) {
        const url = `${environment.OrderApiendpoint}/get-city-state-by-pincode/${pincode}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    getallDOSandId() {
        const url = `${environment.DosApiendpoint}/get-dos-test`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    getallSpecimenandId() {
        const url = `${environment.OrderApiendpoint}/get-specimen`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }


    // -----Import city
    uploadFile(data:any, imagefile: File) {
        const url = `${environment.SettingsApiendpoint}/city_import`;
        const formData = new FormData();
        formData.append('file', imagefile);
            formData.append('customer_id',data.customer_id);
            formData.append('provider_id',data.provider_id);

        return this.httpService
            .post(url, formData, this.httpService.headers)
            .pipe(catchError(this.Errorhandling));
    }

    // ---Export city
    downloadCity() {
        const url = `${environment.SettingsApiendpoint}/city_export`;

        return this.httpService.get(url, this.httpService.headers);


    }

    Errorhandling(err: HttpErrorResponse) {
        if (err.error instanceof ErrorEvent) {
            console.error(err.error.message);
        } else {
            console.error(`Backend returned code ${err.status}`);
        }
        return throwError('Please try again later.');
    }

}
